import './ElementsCarousel.css';

import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { generateClassName } from './helpers';

const ElementsCarousel = ({ elements, onElementSelect, className = null }) => {
    const carouselRef = useRef();
    const [selectedElement, setSelectedElement] = useState(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [carouselElements, setCarouselElements] = useState(elements);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    useEffect(() => {
        if (carouselElements && (carouselElements.length > 0))
            setSelectedElement(null);
    }, [carouselElements]);

    useEffect(() => {
        const checkScrollable = () => {
            const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(scrollLeft < scrollWidth - clientWidth);
        };
        checkScrollable();
        window.addEventListener('resize', checkScrollable);
        carouselRef.current.addEventListener('scroll', checkScrollable);
        return () => {
            window.removeEventListener('resize', checkScrollable);
            if (carouselRef.current) {
                carouselRef.current.removeEventListener('scroll', checkScrollable);
            }
        };
    }, []);

    const scroll = (scrollOffset) => {
        carouselRef.current.scrollLeft += scrollOffset;
    };

    const handleElementClick = (element, index) => {
        if (onElementSelect) {
            setSelectedElement(index);
            onElementSelect(element);
        }
    };

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - carouselRef.current.offsetLeft);
        setScrollLeft(carouselRef.current.scrollLeft);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - carouselRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Adjust the scroll speed
        carouselRef.current.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    return (
        <div className={generateClassName("carousel", "-container", className)}>
            {canScrollLeft && <ChevronLeft className={generateClassName("carousel", "-button", className)} onClick={() => scroll(-80)} />}
            <div
                ref={carouselRef}
                className={generateClassName("carousel", "-elements", className)}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
            >
                {elements.map((element, index) => (
                    <div
                        key={index}
                        className={`${generateClassName("carousel", "-element", className)} ${selectedElement === index ? 'selected' : ''}`}
                        onClick={() => handleElementClick(element, index)}
                    >
                        {element}
                    </div>
                ))}
            </div>
            {canScrollRight && <ChevronRight className={generateClassName("carousel", "-button", className)} onClick={() => scroll(80)} />}
        </div>
    );
};

export default ElementsCarousel;